/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { Link as RouterLink } from 'react-router';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';

class Link extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();

    const { to, onClick, pushState } = this.props;

    if (to) {
      // let openInNewTab = false; // 默认直接在当前页面打开
      let openInNewTab = true; // 点击链接打开新页面
      if (e.metaKey || e.altKey || e.ctrlKey) {
        openInNewTab = true;
      }
      if (openInNewTab) {
        window.open(to);
      } else {
        pushState(to);
      }
    } else {
      onClick(e);
    }
  }

  render() {
    return <RouterLink onClick={this.handleClick}>{this.props.children}</RouterLink>;
  }
}

Link.defaultProps = {
  children: null,
  onClick: () => {},
  to: null,
};
Link.propTypes = {
  children: React.PropTypes.node,
  onClick: React.PropTypes.func,
  to: React.PropTypes.string,
  pushState: React.PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(null, mapDispatchToProps)(Link);




// WEBPACK FOOTER //
// ./src/components/Link.jsx